import { useCallback } from 'react';
import { toastManager } from '../utils/toastManager';
import { ToastVariant } from '../components/ui/Toast';

export const useToast = () => {
  const showToast = useCallback((
    message: string,
    variant: ToastVariant = 'info'
  ) => {
    toastManager.show(variant, message);
  }, []);

  const success = useCallback((title: string, message?: string, duration?: number) => {
    toastManager.show('success', title, message, duration);
  }, []);

  const error = useCallback((title: string, message?: string, duration?: number) => {
    toastManager.show('error', title, message, duration);
  }, []);

  const warning = useCallback((title: string, message?: string, duration?: number) => {
    toastManager.show('warning', title, message, duration);
  }, []);

  const info = useCallback((title: string, message?: string, duration?: number) => {
    toastManager.show('info', title, message, duration);
  }, []);

  const confirm = useCallback((
    title: string,
    message: string,
    options?: {
      confirmText?: string;
      cancelText?: string;
      type?: 'danger' | 'warning' | 'info';
      icon?: 'delete' | 'user-remove' | 'logout' | 'warning';
    }
  ): Promise<boolean> => {
    return toastManager.confirm(title, message, options);
  }, []);

  return {
    showToast,
    success,
    error,
    warning,
    info,
    confirm
  };
};

export default useToast;
